import React from 'react';
import { Link } from '@ktag/styleguide/dist/react';
import { useTranslation } from 'react-i18next';

interface Props {
  title?: string;
  moreLink?: string;
}

const JobsHeader = ({ title, moreLink }: Props) => {
  const { t } = useTranslation('jobs');

  if (!title && !moreLink) {
    return null;
  }

  return (
    <div className="jobs-header">
      {title && <h2 className="h2">{title}</h2>}
      {moreLink && (
        <Link
          href={moreLink}
          icon={{ id: 'tiles' }}
          text={t('jobsheader_morelink_text')}
          additionalClassNames="jobs-header__morelink"
        />
      )}
    </div>
  );
};

export default JobsHeader;
